import styled from 'styled-components';

export const GroupSitesWrapper = styled('div')``;
